import { render } from "./CardListItems.vue?vue&type=template&id=5dca8285&scoped=true"
import script from "./CardListItems.vue?vue&type=script&lang=js"
export * from "./CardListItems.vue?vue&type=script&lang=js"

import "./CardListItems.vue?vue&type=style&index=0&id=5dca8285&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dca8285"]])

export default __exports__